__webpack_require__.p = "https://teccom-portal.staging.tecalliance.cloud/";